import { forwardRef, memo } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = (_ref, ref) => {
  let {
    title,
    titleId,
    desc,
    descId,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    width: "1em",
    height: "1em",
    className: "interstate-megaphone-icon",
    ref: ref,
    "aria-labelledby": titleId,
    "aria-describedby": descId,
    ...props,
    children: [desc ? /*#__PURE__*/_jsx("desc", {
      id: descId,
      children: desc
    }) : null, title ? /*#__PURE__*/_jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/_jsx("path", {
      d: "M13.232.354a.625.625 0 01.802.372 19.747 19.747 0 011.135 5.152c.415.436.67 1.026.67 1.676 0 .65-.255 1.24-.67 1.676a19.778 19.778 0 01-1.136 5.152.625.625 0 11-1.173-.43 18.5 18.5 0 00.13-.366 18.478 18.478 0 00-5.451-1.627c.143.426.307.843.49 1.25.32.712.088 1.595-.63 2.008l-.525.304c-.74.427-1.726.17-2.104-.648a17.334 17.334 0 01-1.102-3.148 4.234 4.234 0 01.725-8.403h.6a18.493 18.493 0 007.995-1.8 18.344 18.344 0 00-.128-.366.625.625 0 01.372-.802zm.125 2.376a19.735 19.735 0 01-6.186 1.724 13.85 13.85 0 00-.35 3.1c0 1.067.121 2.104.35 3.1 2.188.24 4.27.833 6.186 1.724a18.56 18.56 0 00.631-4.824 18.558 18.558 0 00-.631-4.824zm-7.486 7.826a15.12 15.12 0 01-.3-3.002c0-1.027.103-2.03.3-3.001-.291.013-.583.019-.877.019h-.601a2.982 2.982 0 100 5.965h.6c.295 0 .587.006.878.018zm-.897 1.23c.24.887.552 1.743.93 2.562.05.109.2.174.345.09l.526-.303c.121-.07.19-.243.114-.414a14.941 14.941 0 01-.703-1.897 18.966 18.966 0 00-1.192-.037h-.02z"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
const Memo = /*#__PURE__*/memo(ForwardRef);

// eslint-disable-next-line react/no-multi-comp
export const MegaphoneIcon = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx(Memo, {
    ...props,
    ref: ref
  });
});
MegaphoneIcon.displayName = 'MegaphoneIcon';